import { getErrorDescription } from '../../utils/mappers';
export function toError(errorResponse) {
  if (errorResponse.status === 403 && getErrorDescription(errorResponse) === 'Missing Wix session') {
    errorResponse.status = 401;
    errorResponse.data.message = 'Wix Session required';
  }
  return Promise.reject(errorResponse);
}